<template>
  <div class="loginHeader">
    <div class="container">
      <div class="loginHeader__inner">
        <div class="loginHeader__goHome">
          <nuxt-link :to="localePath({ name: 'index' })" class="loginHeader__goHome">
            <span class="loginHeader__button icon-arrow-left" />
            <span class="loginHeader__buttonText">{{ $t('goBack') }}</span>
          </nuxt-link>
        </div>
        <div class="loginHeader__logo">
          <nuxt-link :to="localePath({ name: 'index' })">
            <logo />
          </nuxt-link>
        </div>
        <div class="loginHeader__accountUtils">
          <div class="loginHeader__help">
            <div class="loginHeader__helpWrapper">
              <span class="loginHeader__helpIcon icon-help" />
              <span class="loginHeader__helpText">{{ $t('help') }}</span>
            </div>
            <info-dropdown class="loginHeader__dropdown" />
          </div>
          <div class="loginHeader__account">
            <div class="loginHeader__link loginHeader__link--dropdown">
              <nuxt-link :to="localePath({ name: 'dashboard' })" class="loginHeader__linkInner">
                <!--            <span class="header__linkIcon header__linkIcon&#45;&#45;avatar">-->
                <!--              <span v-if="unreadNotifications" class="header__iconLabel">-->
                <!--                {{ unreadNotifications }}-->
                <!--              </span>-->
                <!--            </span>-->
                <span class="loginHeader__linkIcon icon-user" />
                <span
                  v-if="$auth.isLogged() || $auth.isOnlyUser()"
                  class="loginHeader__linkText loginHeader__linkText--nameMaxWidth"
                >
                  {{ $auth.getStoreUser().firstName }} {{ $auth.getStoreUser().lastName }}
                </span>
                <span class="loginHeader__linkText" v-else>{{ $t('myAccount') }}</span>
              </nuxt-link>
              <account-dropdown
                :menu-items="computedUserMenuData"
                class="loginHeader__linkDropdown"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AccountDropdown from '~/components/AccountDropdown';
import InfoDropdown from '~/components/InfoDropdown';
import Logo from '~/components/Logo';

export default {
  name: 'LoginHeader',
  components: {
    Logo,
    InfoDropdown,
    AccountDropdown,
  },
  computed: {
    ...mapState('layout', ['userMenuData']),
    computedUserMenuData() {
      return this.userMenuData.map(item => ({
        ...item,
        slug: item.to ? item.to : item.href ? item.href : this.localePath({ name: item.slug }),
      }));
    },
  },
};
</script>

<style lang="scss">
.loginHeader {
  $root: &;
  position: relative;
  z-index: $zIndexLayer;
  background-color: $cWhite;

  &__inner {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $cAddLight;
    justify-content: space-between;
    padding: 2.2rem 0;

    @include rwd('tablet') {
      padding: 2.6rem 0;
    }
  }

  &__goHome {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.5rem;
    color: $cAddDark02;
  }

  &__button {
    padding: 0;

    &::before {
      color: $cMain;
      padding-right: 10px;
    }
  }

  &__buttonText {
    @include rwd('laptop') {
      display: none;
    }
  }

  &__logo {
    flex: 0 0 65%;
    max-width: 65%;
    text-align: center;

    & .logo {
      max-height: 39px;
      max-width: 109px;
      margin-left: 25px;

      @include rwd('large-phone') {
        max-height: 36px;
        margin-left: 0;
      }
    }
  }

  &__accountUtils {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    position: relative;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    color: $cAddDark02;
    margin: 0 11px;

    @include rwd('laptop') {
      margin: 0 7px;
    }

    &--dropdown {
      &:after {
        @include icomoon('chevron-down');
        font-size: 7px;
        color: $cMainNeutral;
        margin-left: 10px;
        transition: transform $tr;

        @include rwd('laptop') {
          display: none;
        }
      }

      &:hover {
        &:after {
          transform: rotate(180deg);
        }

        #{$root}__linkDropdown {
          top: 100%;
          opacity: 1;
          pointer-events: all;
        }
      }
    }
  }

  &__linkIcon {
    font-size: 2rem;
    color: $cMain;
    margin-right: 1rem;

    &--list {
      font-size: 1.8rem;
    }
  }

  &__linkText {
    &--nameMaxWidth {
      max-width: 10rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      @include rwd('laptop') {
        max-width: 0;
      }
    }

    @include rwd('laptop') {
      display: none;
    }
  }

  &__linkDropdown {
    padding-top: 4rem;
  }

  &__help {
    position: relative;
    display: flex;
    height: auto;
    align-items: center;
    font-size: 1.4rem;
    line-height: 1.5rem;
    font-weight: 600;
    color: $cAddDark02;
    cursor: pointer;
    padding-right: 2.5rem;

    @include rwd('large-phone') {
      padding-right: 0.8rem;
    }

    &:hover {
      #{$root}__helpWrapper {
        &::after {
          transform: rotate(180deg);
        }
      }

      #{$root}__dropdown {
        padding-top: 4rem;
        top: 100%;
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &__helpWrapper {
    display: flex;
    align-items: center;

    &:after {
      position: relative;
      @include icomoon('chevron-down');
      color: $cMainNeutral;
      font-size: 7px;
      margin-left: 1rem;
      transition: transform $tr;

      @include rwd('laptop') {
        display: none;
      }
    }
  }

  &__helpText {
    @include rwd('laptop') {
      display: none;
    }
  }

  &__helpIcon {
    font-size: 1.7rem;
    margin-right: 1rem;
    color: $cMain;

    @include rwd('tablet') {
      font-size: 1.9rem;
    }
  }
}
</style>
